import "./home.css";
import CertificationsSection from "../../components/certifications/certifications";
import Testimonials from "../../components/testimonials/testimonials";
import ClientLogos from "../../components/client-logo/client-logo";
import OurServices from "../../components/our-services/our-services";
import MainCarousel from "../../components/main-carousal/main-carousal";
import { useTranslation } from "react-i18next";

export default function Home(){
    const { t } = useTranslation()
    return(
        <div className="home-page">
            {/* main hero section */}
            <section className="main-section">
                <MainCarousel />
            </section>

            <section className="client-logos-main-section">
                <ClientLogos/>
            </section>
            <section className="certifications-section">
                <CertificationsSection/>
            </section>
            <section id="ourServices" className="our-services-section">
                <OurServices/>
            </section>
            <section className="sigvion-section">
                <div className="sigvion-container">
                    {/* Left Image */}
                    <div className="sigvion-image">
                        <img src="/assets/images/sigvion-title-logo.webp" alt="sigvion-logo" />
                    </div>

                    {/* Right Text */}
                    <div className="sigvion-content">
                        <p>
                            {t("Specializing in high-caliber IT solutions and services, Sigvion delivers tailored strategies that drive innovation, efficiency, and business process automation.")}
                        </p>
                        <p>
                          {t("Our focus on facilitating digital transitions and elevating business performance guarantees your enterprise’s success. We ensure strict compliance with industry norms while maintaining an unwavering commitment to quality.")}
                        </p>
                    </div>
                </div>
            </section>
            <section className="partnership-section">
                <div className="partnership-container">
                    <p className="partnership-subheading">{t("Collaborate for Success")}</p>
                    <h2>{t("Partnership Advantage")}</h2>
                    <div className="partnership-details">
                        <p>
                            {t("Sigvion provides end-to-end consulting services for digital transformation and AI enablement, helping enterprises harness technology to drive meaningful business outcomes. With roots in California and Texas, and a strong presence in Hyderabad and Bengaluru, our growing team of over 200 passionate technologists and business process experts operates globally to deliver impact at scale.")}
                        </p>
                        <p>
                            {t("Backed by over two decades of experience in enterprise software solutions, Sigvion has built a reputation for quality, innovation, and trust partnering with organizations of all sizes and industries to navigate their digital journey with confidence.")}
                        </p>
                    </div>
                </div>
            </section>
            <section className="testimonials-section">
                <Testimonials/>
            </section>
        </div>
    )    
}